import { imageStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsImage";
import { css } from "styled-components";

Object.assign(imageStyles, {
    ...imageStyles,
    linksItem: {
        css: css`
            display: none;
        `,
    },
    imageMissingText: {
        css: css`
            display: none;
        `,
    },
});
